export const API_KEY = "63fcf6ac9a00124665e8461cfe2370bb";
export const API_URL = "https://api.openweathermap.org/data/2.5/weather";
